const About = () => {
  return (
    <section
      id="a-propos"
      className="py-20 md:py-28 bg-gray-50"
      aria-labelledby="about-title"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          {/* Section Header */}
          <h2
            id="about-title"
            className="text-3xl md:text-4xl font-semibold text-gray-900 tracking-tight font-['Manrope'] mb-8"
          >
            Qui sommes-nous ?
          </h2>

          {/* Content */}
          <div className="space-y-6 text-gray-600 leading-relaxed">
            <p>
              <strong className="text-gray-900">Performance Transmission</strong> est une fiduciaire 
              basée en Suisse romande, à Tolochenaz dans le canton de Vaud. Nous accompagnons 
              les entrepreneurs, indépendants et dirigeants de PME dans la gestion de leurs 
              obligations comptables et fiscales.
            </p>
            <p>
              Notre mission est simple : vous libérer des contraintes administratives pour que 
              vous puissiez vous concentrer sur ce qui compte vraiment — le développement de 
              votre activité. Nous croyons qu'une comptabilité bien tenue est le socle d'une 
              entreprise sereine.
            </p>
            <p>
              Notre approche se veut moderne et personnalisée. Chaque client bénéficie d'un 
              suivi sur mesure, avec un interlocuteur unique qui comprend les spécificités de 
              son secteur. Nous utilisons des outils numériques performants tout en maintenant 
              une relation humaine de proximité.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
